import { last, nonNullable, take } from 'lib/array/arrayUtils'
import { useCallback, useState } from 'react'

function useStack<T>(value?: T): [
  current: T | undefined,
  pop: () => T | undefined,
  push: (value?: T) => void,
  stack: Array<T>,
] {
  const [stack, setStack] = useState<Array<T>>(() => nonNullable([value]))

  const current = last(stack)
  const pop = useCallback(() => {
    const previousValue = stack.at(-2)

    setStack((prevStack) => {
      return take(prevStack, prevStack.length - 1)
    })

    return previousValue
  }, [stack])

  const push = useCallback((value: T) => {
    setStack([...stack, value])
  }, [stack])

  return [
    current,
    pop,
    push,
    stack,
  ]
}

export default useStack
